import { render, staticRenderFns } from "./rsvp.vue?vue&type=template&id=d3540772&scoped=true&"
import script from "./rsvp.vue?vue&type=script&lang=js&"
export * from "./rsvp.vue?vue&type=script&lang=js&"
import style0 from "./rsvp.vue?vue&type=style&index=0&id=d3540772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3540772",
  null
  
)

export default component.exports